import Ajax from '@lib/ajax'

export default {
  async createEdit(payload){
    return Ajax.post('/api/services/app/SchoolClass/CreateEdit',payload);
  },
  async create(payload){
    return Ajax.post('/api/services/app/SchoolClass/Create',payload.data);
  },
  async update(payload){
    return Ajax.put('/api/services/app/SchoolClass/Update',payload.data);
  },
  async delete(id){
    return Ajax.delete('/api/services/app/SchoolClass/Delete?Id='+ id);
  },
  async get(id){
    return Ajax.get('/api/services/app/SchoolClass/Get?Id='+ id);
  },
  async getAll(payload){
    return Ajax.get('/api/services/app/SchoolClass/GetAll',{params:payload.data});
  },
  async getSchoolClassGridResult(payload){
    return Ajax.get('/api/services/app/SchoolClass/GetSchoolClassGridResult', payload);
  },
  async find(query) {
    return Ajax.post('/api/services/app/SchoolClass/Find', { query: query })
  },
  async getSchoolCalssesWithNumbers() {
    return Ajax.get('/api/services/app/SchoolClass/GetSchoolCalssesWithNumbers')
  },

  
}